import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Button } from "~/components/Button/Button"
import { CalendarFilter } from "~/components/FilterWrapper/components/CalendarFilter/CalendarFilter"
import { CategoryFilter } from "~/components/FilterWrapper/components/CategoryFilter/CategoryFilter"
import { NameFilter } from "~/components/FilterWrapper/components/NameFilter/NameFilter"
import { StatusFilter } from "~/components/FilterWrapper/components/StatusFilter/StatusFilter"
import { useFilterContext } from "~/components/FilterWrapper/FilterWrapper"

import styles from "./index.module.css"

export const Filter: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Filters}>
      <div className={styles.StatusFilter}>
        <StatusFilter
          activeLabel={t("procurements.Filter.Status.active")}
          closedLabel={t("procurements.Filter.Status.closed")}
        />
      </div>

      {/*<div className={styles.Grid}>*/}
      {/*  <NameFilter placeholder={t("procurements.Filter.Name.placeholder")} />*/}
      {/*  <CategoryFilter />*/}
      {/*  <CalendarFilter />*/}
      {/*</div>*/}
      <SelectedCategoies />
    </div>
  )
}

const SelectedCategoies: React.FC = () => {
  const categories = useApiContext("/procurementcategories/list")
  const { updateFilterState, filterState } = useFilterContext()
  if (categories.length === 0) {
    return null
  }

  const selectedCategories = categories.filter(({ id }) =>
    filterState?.categories_arr?.includes(id),
  )

  const resetCategory = (categoryId: string): void => {
    const newCategories = selectedCategories
      .filter(({ id }) => categoryId !== id)
      .map(({ id }) => id)

    updateFilterState({ categories_arr: newCategories })
  }

  const resetCategories = (): void => {
    updateFilterState({ categories_arr: [] })
  }

  if (selectedCategories.length === 0) {
    return null
  }

  return (
    <div className={styles.Categories}>
      {selectedCategories.map(({ name, id }) => (
        <Button
          key={id}
          className={styles.Category}
          view="rounded"
          onClick={() => resetCategory(id)}
        >
          <div className={styles.CategoryName}>{name}</div>
          {<div className={styles.Reset} />}
        </Button>
      ))}
      <Button className={styles.ResetCategories} view="rounded" onClick={resetCategories}>
        Очистить
      </Button>
    </div>
  )
}
